import { render, staticRenderFns } from "./TeacherStaffAdmin.vue?vue&type=template&id=454fe781"
import script from "./TeacherStaffAdmin.vue?vue&type=script&lang=js"
export * from "./TeacherStaffAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports